import { Reveal, Eyebrow } from "@/components/Reveal";

const SERVICES = [
  {
    id: "regular",
    name: "Lastenhoito",
    price: "25 € / h",
    priceNote: "1 lapsi · 30 € / h kahdella lapsella",
    desc: "Rauhallista hoitoa perheenne omassa kodissa: leikkiä, ulkoilua ja iltarutiineja juuri teidän tapojenne mukaan. Lapsi viihtyy tutussa ympäristössään – ja te saatte nauttia omasta ajastanne. Vähimmäisvaraus 3 tuntia.",
    accent: false,
  },
  {
    id: "intro",
    name: "Tutustumiskäynti",
    price: "25 € / 1 h",
    priceNote: "tai 35 € / 2 h · halutessanne ennen hoitoa",
    desc: "Tulen mielelläni tutustumiskäynnille, jos koette sen mukavana alkuna. Myös soittaminen onnistuu – on ymmärrettävää, että hoitajan kanssa on kiva jutella ja tutustua jo ennen ensimmäistä hoitokertaa.",
    accent: true,
  },
  {
    id: "sick",
    name: "Sairaan lapsen hoito",
    price: "35 € / h / lapsi",
    priceNote: "oma selkeä palvelunsa",
    desc: "Kun lapsi on sairas ja tarvitsee kotiin rauhallista aikuista seuraa, tulen mielellään vahtimaan ja hoitamaan häntä: lepoa, juomista ja lämpimiä hetkiä.",
    accent: false,
  },
];

export const Services = () => (
  <section id="palvelut" className="bg-greige/60 py-24 sm:py-32" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-12 sm:mb-14">
        <Reveal>
          <Eyebrow index="04" label="Palvelut" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl font-medium tracking-tight text-petrol-night sm:text-5xl">
            Selkeät palvelut, huolellinen tekeminen
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={0.1 * i} className="h-full">
            <div
              data-testid={`services-card-${s.id}`}
              className={`flex h-full flex-col rounded-[1.75rem] p-8 transition-all duration-500 hover:-translate-y-1.5 sm:p-9 ${
                s.accent
                  ? "bg-petrol text-cream shadow-[0_35px_70px_-30px_rgba(18,58,62,0.55)]"
                  : "border border-line bg-cream hover:shadow-[0_25px_55px_-30px_rgba(18,58,62,0.35)]"
              }`}
            >
              <div className="flex items-center justify-between">
                <h3 className={`font-serif text-[1.7rem] font-semibold leading-tight ${s.accent ? "text-cream" : "text-petrol-night"}`}>
                  {s.name}
                </h3>
                <span
                  className={`h-2 w-2 rounded-full ${s.accent ? "bg-beige" : "bg-beige-deep"}`}
                  aria-hidden="true"
                />
              </div>
              <p className={`mt-5 font-serif text-3xl font-medium tracking-tight ${s.accent ? "text-beige" : "text-petrol"}`}>
                {s.price}
              </p>
              <p className={`mt-1 text-xs font-medium uppercase tracking-[0.14em] ${s.accent ? "text-cream/60" : "text-mutedink/80"}`}>
                {s.priceNote}
              </p>
              <p className={`mt-6 text-[0.95rem] leading-relaxed ${s.accent ? "text-cream/85" : "text-mutedink"}`}>
                {s.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
